import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider, useLanguage } from "@/context/LanguageContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Footer from "@/components/site/Footer";
import SoundToggle from "@/components/site/SoundToggle";
import {
  AboutSection,
  EcosystemSection,
  WhySection,
  StatementSection,
  FinalCTA,
} from "@/components/site/Sections";

function MainContent() {
  const { t } = useLanguage();

  return (
    <div className="App relative bg-background text-foreground">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee testId="marquee-top" items={t.marquee} />
        <AboutSection />
        <EcosystemSection />
        <WhySection />
        <StatementSection />
        <FinalCTA />
      </main>
      <Footer />
      <SoundToggle />
    </div>
  );
}

function LandingPageWrapper() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return <MainContent />;
}

function RootRedirect() {
  const { lang } = useLanguage();
  return <Navigate to={`/${lang}/`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          {/* Root redirect to auto-detected /id/ or /en/ */}
          <Route path="/" element={<RootRedirect />} />

          {/* Language landing routes */}
          <Route path="/id" element={<LandingPageWrapper />} />
          <Route path="/id/*" element={<LandingPageWrapper />} />
          <Route path="/en" element={<LandingPageWrapper />} />
          <Route path="/en/*" element={<LandingPageWrapper />} />

          {/* Fallback */}
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
